import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📱 Native`}</h2>
    <ul>
      <li parentName="ul">{`There’s now a Partial Sheet component for iOS. (Dan S.)`}</li>
      <li parentName="ul">{`Checkbox for Android is now complete. (Brian T.)`}</li>
      <li parentName="ul">{`Next week we’re starting work on the Dropdown, Toggle Chip, Filter Chip, Pill, Banner, and Toast components for Android as well as Banner and Toast components for iOS. The API reviews for these components will be this week.`}</li>
      <li parentName="ul">{`Thumbprint Tokens is now published to JitPack for use in the Android codebase. The Design Systems team is working with Android engineers to get the package up and running in the Android codebase. (Daniel O.)`}</li>
    </ul>
    <h2>{`🍭 Design`}</h2>
    <ul>
      <li parentName="ul">{`Native-friendly icons are now in Thumbprint. (Jon K.)`}</li>
      <li parentName="ul">{`The Calendar component has shipped. (Jon K.)`}</li>
      <li parentName="ul">{`Banners and Toasts are in review. (Jon K.)`}</li>
      <li parentName="ul">{`Our `}<a parentName="li" {...{
          "href": "/guide/product/spacers/"
        }}>{`spacing guidelines`}</a>{` were updated to reflect the differences between web and native values. (Tom G.)`}</li>
    </ul>
    <h2>{`🖥 Web`}</h2>
    <ul>
      <li parentName="ul">{`The Input component now support `}<inlineCode parentName="li">{`forwardRef`}</inlineCode>{`. (Giles L., Matty B.)`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      